/**************************************************
 * Nombre:       Nosotros_Mision_Vision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import mision from '../../../Recursos/mision.png'
import vision from '../../../Recursos/vision.png'
import Tarjeta_Mision from "../../Tarjetas/Tarjeta_Mision";

const Nosotros_Mision_Vision = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={6}
                    >

                        {items.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Mision item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Mision_Vision


const items = [
    {
        nombre: 'Mision',
        imagen: mision,
        descripcion: 'Somos una empresa turística con la capacidad de ofrecer servicios acordes al interes de cada viajero, y que cumplan con sus expectativas, gracias a la inversion en tecnologia de punta, el talento humano calificado y experiencia en el campo.'

    },
    {
        nombre: 'Vision',
        imagen: vision,
        descripcion: 'En 2030 ser la empresa turística reconocida por la excelencia de nuestros productos y servicios, a través del incremento y fidelización de nuestros clientes.'

    },
]